import React from "react";
import { Smartphone } from "lucide-react";

const PlayTriangle = () => (
    <svg width="20" height="22" viewBox="0 0 20 22" aria-hidden="true" className="shrink-0">
        <defs>
            <linearGradient id="biofood-gp" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#00C3FF" />
                <stop offset="0.4" stopColor="#1CE783" />
                <stop offset="0.72" stopColor="#FFD200" />
                <stop offset="1" stopColor="#FF4B5C" />
            </linearGradient>
        </defs>
        <path d="M1.5 1.2 L18 11 L1.5 20.8 Z" fill="url(#biofood-gp)" />
    </svg>
);

const badgeCls = (dark) =>
    `group inline-flex items-center gap-3 rounded-xl bg-black px-4 h-[52px] text-white transition-[transform,background-color] duration-200 hover:bg-neutral-900 hover:-translate-y-0.5 shadow-lg ${
        dark ? "border border-white/20" : "border border-black/10"
    }`;

export const StoreBadges = ({ dark = false, className = "" }) => (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
        <a href="#" data-testid="badge-google-play" aria-label="Disponible en Google Play" className={badgeCls(dark)}>
            <PlayTriangle />
            <span className="flex flex-col leading-none text-left">
                <span className="text-[10px] font-medium tracking-wide text-white/70">DISPONIBLE EN</span>
                <span className="text-[17px] font-semibold -mt-0.5">Google Play</span>
            </span>
        </a>
        <a href="#" data-testid="badge-app-store" aria-label="Descárgalo en el App Store" className={badgeCls(dark)}>
            <Smartphone className="h-5 w-5 shrink-0" strokeWidth={2.2} />
            <span className="flex flex-col leading-none text-left">
                <span className="text-[10px] font-medium tracking-wide text-white/70">DESCÁRGALO EN</span>
                <span className="text-[17px] font-semibold -mt-0.5">App Store</span>
            </span>
        </a>
    </div>
);
